<template>
  <svg
    v-if="paths"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="name === 'npm' ? 'currentColor' : 'none'"
    stroke="currentColor"
    :stroke-width="name === 'npm' ? 0 : strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    v-html="paths"
  />
</template>

<script setup>
import { computed } from 'vue';

// Glyphs describe what KIND of thing a project is — not what it's about.
// Values are static author-written SVG fragments (never user input), so
// v-html is safe and avoids a long v-if chain.
const GLYPHS = Object.freeze({
  web: '<circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3c2.6 2.7 3.9 5.7 3.9 9s-1.3 6.3-3.9 9c-2.6-2.7-3.9-5.7-3.9-9s1.3-6.3 3.9-9z"/>',
  app: '<rect x="7" y="2" width="10" height="20" rx="2.5"/><line x1="11" y1="18.5" x2="13" y2="18.5"/>',
  hybrid: '<rect x="2" y="4" width="13" height="10" rx="1.8"/><path d="M6 18h6"/><rect x="17" y="9" width="5" height="11" rx="1.6"/>',
  github: '<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/>',
  // npm's wordmark is solid rather than stroked, hence the fill/stroke swap above.
  npm: '<path d="M2 9h20v6h-10v1.5H8V15H2z m2 2v2h2v-2h1v2h1v-3H4z m6 0v3h2v-2h1v2h1v-3h-4z m6 0v2h2v-2h1v3h-4v-3z"/>',
});

const props = defineProps({
  name: { type: String, default: null },
  fallback: { type: String, default: null },
  size: { type: [Number, String], default: 16 },
  strokeWidth: { type: [Number, String], default: 1.7 },
});

const paths = computed(() => GLYPHS[props.name] || GLYPHS[props.fallback] || null);
</script>
